var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 16.0417C9.76356 16.0417 9.56565 15.9618 9.40592 15.8021C9.2462 15.6424 9.16634 15.4444 9.16634 15.2083V10.8333H4.79134C4.55523 10.8333 4.35731 10.7535 4.19759 10.5937C4.03787 10.434 3.95801 10.2361 3.95801 10C3.95801 9.76389 4.03787 9.56597 4.19759 9.40625C4.35731 9.24653 4.55523 9.16667 4.79134 9.16667H9.16634V4.79167C9.16634 4.55555 9.2462 4.35764 9.40592 4.19792C9.56565 4.03819 9.76356 3.95833 9.99967 3.95833C10.2358 3.95833 10.4337 4.03819 10.5934 4.19792C10.7531 4.35764 10.833 4.55555 10.833 4.79167V9.16667H15.208C15.4441 9.16667 15.642 9.24653 15.8018 9.40625C15.9615 9.56597 16.0413 9.76389 16.0413 10C16.0413 10.2361 15.9615 10.434 15.8018 10.5937C15.642 10.7535 15.4441 10.8333 15.208 10.8333H10.833V15.2083C10.833 15.4444 10.7531 15.6424 10.5934 15.8021C10.4337 15.9618 10.2358 16.0417 9.99967 16.0417Z",
    fill: "#2D2F35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.c335b5f58495ac2e59ccbd6a769e56ea.svg";
export { ForwardRef as ReactComponent };